import { render, staticRenderFns } from "./ProjectVersionPreviewDelete.vue?vue&type=template&id=d4513b54&lang=pug&"
import script from "./ProjectVersionPreviewDelete.vue?vue&type=script&lang=js&"
export * from "./ProjectVersionPreviewDelete.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVersionPreviewDelete.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports